"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LuxonDateTimeFormatStringRegex = exports.Reporting = exports.RecurringDate = exports.NonBusinessDayAdjustmentSchema = exports.DayIterable = void 0;
const v4_1 = require("zod/v4");
const Util = __importStar(require("./Utils"));
// Week starts with Monday (1) and ends with Sunday (7).
const WeekdaySchema = v4_1.z.union([
    v4_1.z.literal(1),
    v4_1.z.literal(2),
    v4_1.z.literal(3),
    v4_1.z.literal(4),
    v4_1.z.literal(5),
    v4_1.z.literal(6),
    v4_1.z.literal(7),
]);
exports.DayIterable = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];
const DayUnitSchema = v4_1.z.enum(['businessDay', 'calendarDay']);
exports.NonBusinessDayAdjustmentSchema = v4_1.z.enum(['before', 'after']);
var RecurringDate;
(function (RecurringDate) {
    // ====== Building Blocks =======
    // ====== Offset Operation =======
    // offset by calendar days or business days
    const AbstractDateOffsetSchema = v4_1.z.object({
        days: v4_1.z.number(),
        dayUnit: DayUnitSchema,
    });
    const BusinessDateOffsetSchema = AbstractDateOffsetSchema.extend({
        dayUnit: v4_1.z.literal('businessDay'),
    });
    const CalendarDateOffsetSchema = AbstractDateOffsetSchema.extend({
        dayUnit: v4_1.z.literal('calendarDay'),
        nonBusinessDayAdjustment: v4_1.z.optional(exports.NonBusinessDayAdjustmentSchema),
    });
    const DateOffsetSchema = v4_1.z.union([
        BusinessDateOffsetSchema,
        CalendarDateOffsetSchema,
    ]);
    /**
     * ### Valid Base Date Config Types
     *
     * - types in order of which type is used more frequently
     * - no daily because weekly can do all days of week if all selected
     */
    const BaseDateConfigTypeSchema = v4_1.z.enum([
        'weekday',
        'calendarDate',
        'startOf',
        'endOf',
        'weekdayByOccurrence',
    ]);
    const FrequencyPeriodSchema = v4_1.z.enum(['week', 'month', 'quarter', 'year']);
    const ReccuringFrequencyPeriodSchema = v4_1.z.enum(['month', 'quarter', 'year']);
    const AbstractBaseDateConfigSchema = v4_1.z.object({
        type: BaseDateConfigTypeSchema,
        cadence: v4_1.z.number(),
        offset: v4_1.z.optional(DateOffsetSchema),
    });
    // ====== Start of/ End of period =======
    const AbstractStartOrEndOfPeriodRecurringDateConfigSchema = AbstractBaseDateConfigSchema.extend({
        type: v4_1.z.enum(['startOf', 'endOf']),
        period: ReccuringFrequencyPeriodSchema,
    });
    /**
     * ### Start of Period Recurring Date Config
     *
     * Uses the `startDate` to calculate the start of the period (and month if quarter or year)
     *
     * - `Offset` is applied to the calculated start of the period
     *
     * - `Cadence` is applied to the calculated start of the period
     *
     * - Calculated dates falling outside of the range [`startDate`, `endDate`] are omitted
     * #### _Example:_
     *
     * Template:
     * [configType] [period], once every [cadence] [period] for dates ranging between [startDate] to [endDate]
     *
     * Example Case:
     * [**Start of**] [**month**], once every [**2**] [**months**] ranging between [**1/15/2020**] to [**5/1/2020**]
     *
     * ```js
     * {
     *   type: BaseDateConfigType.EndOf,
     *   startDate: '2020-01-15',
     *   endDate: '2020-05-01',
     *   period: 'month',
     *   cadence: 2,
     * }
     * ```
     */
    const AbstractStartOfPeriodRecurringDateConfigSchema = AbstractStartOrEndOfPeriodRecurringDateConfigSchema.extend({
        type: v4_1.z.literal('startOf'),
        period: ReccuringFrequencyPeriodSchema,
    });
    const StartOfPeriodRecurringDateConfigSchema = AbstractStartOfPeriodRecurringDateConfigSchema.extend({
        startDate: Util.ZodFullDateStrForJsonSchemaStruct,
        endDate: Util.ZodFullDateStrForJsonSchemaStruct,
    });
    /**
     * ### End of Period Recurring Date Config
     *
     * Uses the `startDate` to calculate the end of the period (and month if quarter or year)
     *
     * - `Offset` is applied to the calculated start of the period
     *
     * - `Cadence` is applied to the calculated start of the period
     *
     * - Calculated dates falling outside of the range [`startDate`, `endDate`] are omitted
     *
     * #### _Example:_
     *
     * Template:
     * [offset] [configType] [period], once every [cadence] [period] for dates ranging between [startDate] to [endDate]
     *
     * Example Case:
     * [1 calendar day after] [**End of**] [**month**], once every [**2**] [**months**] ranging between [**1/15/2020**] to [**5/1/2020**]
     *
     * ```js
     * {
     *   type: BaseDateConfigType.EndOf,
     *   startDate: '2020-01-15',
     *   endDate: '2020-05-01',
     *   period: 'month',
     *   cadence: 2,
     *   offset: {
     *     dayUnit: 'calendarDay',
     *     days: 1,
     *   }
     * }
     * ```
     */
    const AbstractEndOfPeriodRecurringDateConfigSchema = AbstractStartOrEndOfPeriodRecurringDateConfigSchema.extend({
        type: v4_1.z.literal('endOf'),
        period: ReccuringFrequencyPeriodSchema,
    });
    const EndOfPeriodRecurringDateConfigSchema = AbstractEndOfPeriodRecurringDateConfigSchema.extend({
        startDate: Util.ZodFullDateStrForJsonSchemaStruct,
        endDate: Util.ZodFullDateStrForJsonSchemaStruct,
    });
    // ====== Calendar Date =======
    /**
     * ### Calendar Date Config
     *
     * Uses the `startDate` to iterate over a set `cadence` of `period` until the `endDate` is reached
     *
     * #### _Example:_
     *
     * Template:
     * [offset] [startDate.fragment], once every [cadence] [period] on [startDate.fragment] for dates ranging between [startDate] to [endDate]
     *
     * Example Case:
     * [1 business day before] [**the 15th**], once every [**2**] [**months**] on ranging between [**1/15/2020**] to [**5/1/2020**]
     *
     * ```js
     * {
     *   type: BaseDateConfigType.CalendarDate,
     *   startDate: '2020-01-15',
     *   endDate: '2020-05-01',
     *   period: 'month',
     *   cadence: 2,
     *   offset: {
     *     dayUnit: 'businessDay',
     *     days: -1,
     *   }
     * }
     * ```
     *
     * Example Case:
     * [1 business day before] [**January 15th**], once every [**2**] [**years**] ranging between [**1/15/2020**] to [**5/1/2020**]
     *
     * ```js
     * {
     *   type: BaseDateConfigType.CalendarDate,
     *   startDate: '2020-01-15',
     *   endDate: '2020-05-01',
     *   period: 'year',
     *   cadence: 2,
     *   offset: {
     *     dayUnit: 'businessDay',
     *     days: -1,
     *   }
     * }
     * ```
     */
    const AbstractCalendarDateConfigSchema = AbstractBaseDateConfigSchema.extend({
        type: v4_1.z.literal('calendarDate'),
        period: ReccuringFrequencyPeriodSchema,
    });
    const CalendarDateConfigSchema = AbstractCalendarDateConfigSchema.extend({
        startDate: Util.ZodFullDateStrForJsonSchemaStruct,
        endDate: Util.ZodFullDateStrForJsonSchemaStruct,
    });
    // ====== Weekday =======
    const BaseWeekdayConfigSchema = AbstractBaseDateConfigSchema.extend({
        type: v4_1.z.enum(['weekday', 'weekdayByOccurrence']),
        period: v4_1.z.union([v4_1.z.literal('week'), ReccuringFrequencyPeriodSchema]),
        weekdays: v4_1.z.array(WeekdaySchema),
    });
    const AbstractWeekdayConfigSchema = BaseWeekdayConfigSchema.extend({
        type: v4_1.z.literal('weekday'),
        period: v4_1.z.literal('week'),
    });
    const WeekdayConfigSchema = AbstractWeekdayConfigSchema.extend({
        startDate: Util.ZodFullDateStrForJsonSchemaStruct,
        endDate: Util.ZodFullDateStrForJsonSchemaStruct,
    });
    // ====== Relative Occurrence by Weekday =======
    const AbstractRelativeWeekdayOccurrenceConfigSchema = BaseWeekdayConfigSchema.extend({
        type: v4_1.z.literal('weekdayByOccurrence'),
        period: ReccuringFrequencyPeriodSchema,
        occurrence: v4_1.z.number(),
    });
    const RelativeWeekdayOccurrenceConfigSchema = AbstractRelativeWeekdayOccurrenceConfigSchema.extend({
        startDate: Util.ZodFullDateStrForJsonSchemaStruct,
        endDate: Util.ZodFullDateStrForJsonSchemaStruct,
    });
    /** Fixed Recurring Date Config (these all require startDate and endDate) */
    const BaseRecurringDateConfigSchema = v4_1.z.union([
        StartOfPeriodRecurringDateConfigSchema,
        EndOfPeriodRecurringDateConfigSchema,
        CalendarDateConfigSchema,
        WeekdayConfigSchema,
        RelativeWeekdayOccurrenceConfigSchema,
    ]);
    const BaseDateConfigSchema = v4_1.z.union([
        BaseRecurringDateConfigSchema,
        v4_1.z.array(Util.ZodFullDateStrForJsonSchemaStruct),
    ]);
    RecurringDate.ConfigSchema = v4_1.z.object({
        recurringDateConfigs: v4_1.z.array(BaseDateConfigSchema),
        exclusions: v4_1.z.array(BaseDateConfigSchema),
    });
})(RecurringDate || (exports.RecurringDate = RecurringDate = {}));
var Reporting;
(function (Reporting) {
    // all resolved start and end dates are inclusive
    Reporting.PeriodIterable = [
        // resolves to start=reportingDate; end=reportingDate
        // reportingDate 2023-10-23 => start: 2023-10-23; end: 2023-10-23;
        'calendarDay',
        // resolves to start=1st day of calendar week; end=last day of calendar week
        // optional weekStartDay parameter to set start day of week, defaults to Monday
        // reportingDate 2023-10-24 (Tuesday) => start: 2023-10-23 (Monday); end: 2023-10-29 (Sunday);
        'calendarWeek',
        // resolves to start=1st day of calendar month; end=last day of calendar month
        // reportingDate 2023-01-16 => start: 2023-01-01; end: 2023-01-31;
        'calendarMonth',
        // resolves to start=1st day of calendar quarter; end=last day of calendar quarter
        // calendar quarters: Q1=1/1-3/31; Q2=4/1-6/30; Q3=7/1-9/30; Q4=10/1-12/31
        // reportingDate 2023-01-16 => start: 2023-01-01; end: 2023-03-31;
        'calendarQuarter',
        // resolves to start=1st day of calendar year; end=last day of calendar year
        // calendar year: 1/1-12/31
        // reportingDate 2023-01-16 => start: 2023-01-01; end: 2023-12-31;
        'calendarYear',
    ];
    // we construct ReportingPeriod data structure from encoded formula engine string
    // for use within LoanTapeMetadata framework. When adding new reportingPeriod properties
    // please update this const and LoanTapeMetadata framework.
    Reporting.AllReportingPeriodPropertiesIterable = [
        'period',
        'weekStartDay',
    ];
})(Reporting || (exports.Reporting = Reporting = {}));
exports.LuxonDateTimeFormatStringRegex = /^(?:\s|'.*'|\W)*(?:S|SSS|u|uu|uuu|s|ss|m|mm|h|hh|H|HH|Z|ZZ|ZZZ|ZZZZ|ZZZZZ|z|a|d|dd|c|ccc|cccc|ccccc|L|M|LL|MM|LLL|MMM|LLLL|MMMM|LLLLL|MMMMM|y|yy|yyyy|G|GG|GGGGG|kk|kkkk|W|WW|o|ooo|q|qq|D|DD|DDD|DDDD|t|tt|ttt|tttt|T|TT|TTT|TTTT|f|ff|fff|ffff|F|FF|FFF|FFFF|X|x)+(?:S|SSS|u|uu|uuu|s|ss|m|mm|h|hh|H|HH|Z|ZZ|ZZZ|ZZZZ|ZZZZZ|z|a|d|dd|c|ccc|cccc|ccccc|L|M|LL|MM|LLL|MMM|LLLL|MMMM|LLLLL|MMMMM|y|yy|yyyy|G|GG|GGGGG|kk|kkkk|W|WW|o|ooo|q|qq|D|DD|DDD|DDDD|t|tt|ttt|tttt|T|TT|TTT|TTTT|f|ff|fff|ffff|F|FF|FFF|FFFF|X|x|\s|'.*'|\W)*$/;
//# sourceMappingURL=Date.js.map